import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=2b9824d7&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
import style0 from "./Login.vue?vue&type=style&index=0&id=2b9824d7&prod&lang=scss&scoped=true"
import style1 from "./Login.vue?vue&type=style&index=1&id=2b9824d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9824d7",
  null
  
)

export default component.exports